var _rect, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGooglePay = function SvgGooglePay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 50,
    height: 35,
    rx: 3.5,
    fill: "#FBFCFF",
    stroke: "#D5E3ED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#GooglePay_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.125 18.2v3.72h-1.2v-9.198h3.12c.76 0 1.48.28 2.039.8.56.48.84 1.2.84 1.96 0 .759-.28 1.439-.84 1.959-.56.52-1.24.8-2.04.8l-1.919-.04Zm0-4.358v3.199h2c.44 0 .88-.16 1.16-.48.64-.6.64-1.6.04-2.2l-.04-.04c-.32-.32-.72-.52-1.16-.48h-2ZM31.683 15.441c.88 0 1.56.24 2.08.72s.759 1.12.759 1.92v3.838h-1.12v-.88h-.04c-.48.72-1.16 1.08-1.959 1.08-.68 0-1.28-.2-1.76-.6-.44-.4-.72-.96-.72-1.56 0-.64.24-1.159.72-1.559.48-.4 1.16-.56 1.96-.56.72 0 1.28.12 1.72.4v-.28c0-.4-.16-.8-.48-1.04-.32-.28-.72-.44-1.16-.44-.68 0-1.2.28-1.56.84l-1.04-.64c.64-.839 1.48-1.239 2.6-1.239ZM30.163 20c0 .32.16.6.4.76.28.2.6.32.92.32.48 0 .96-.2 1.32-.56.4-.36.6-.8.6-1.28-.36-.28-.88-.44-1.56-.44-.48 0-.88.12-1.2.36-.32.2-.48.48-.48.84ZM41 15.641l-3.959 9.077h-1.2l1.48-3.159-2.599-5.878h1.28L37.88 20.2h.04l1.84-4.519H41v-.04Z",
    fill: "#5F6368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.367 17.4c0-.36-.04-.72-.08-1.08h-4.999v2.04h2.84c-.12.64-.48 1.24-1.04 1.6v1.32h1.72c.999-.92 1.559-2.28 1.559-3.88Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.288 22.559c1.44 0 2.64-.48 3.52-1.28l-1.72-1.32c-.48.32-1.08.52-1.8.52-1.36 0-2.559-.92-2.959-2.199H9.57v1.36c.92 1.8 2.72 2.919 4.72 2.919Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.33 18.28c-.24-.64-.24-1.36 0-2.04v-1.359H9.57c-.76 1.48-.76 3.24 0 4.759l1.76-1.36Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.288 14.082c.76 0 1.48.28 2.04.8l1.52-1.52c-.96-.88-2.24-1.4-3.52-1.36-1.999 0-3.838 1.12-4.718 2.92l1.76 1.359c.36-1.28 1.559-2.2 2.918-2.2Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "GooglePay_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "matrix(1 0 0 -1 9 28)",
    d: "M0 0h32v20H0z"
  })))));
};

export default SvgGooglePay;